/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Dry_QuantityInputs */

const vi_tea_purchase_dry_quantity = /** @type {(inputs: Tea_Purchase_Dry_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng khô (kg)`)
};

/**

* @param {Tea_Purchase_Dry_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_dry_quantity = /** @type {((inputs?: Tea_Purchase_Dry_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Dry_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_dry_quantity(inputs)
});